import { render, staticRenderFns } from "./addOrEditProduct.vue?vue&type=template&id=8ac8a8e0&scoped=true"
import script from "./addOrEditProduct.vue?vue&type=script&lang=js"
export * from "./addOrEditProduct.vue?vue&type=script&lang=js"
import style0 from "./addOrEditProduct.vue?vue&type=style&index=0&id=8ac8a8e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac8a8e0",
  null
  
)

export default component.exports